import { Tabs, Typography } from "antd";
import ExpenseTypes from "./components/ExpenseTypes";
import ExpenseCategories from "./components/ExpenseCategories";
import ExpenseDescriptions from "./components/ExpenseDescriptions";
import ExpenseSuppliers from "./components/ExpenseSuppliers";
import ExpenseUnits from "./components/ExpenseUnits";

const ManageExpense = () => {
  const items = [
    {
      key: "types",
      label: "Types",
      children: <ExpenseTypes />,
    },
    {
      key: "units",
      label: "Units",
      children: <ExpenseUnits />,
    },
    {
      key: "suppliers",
      label: "Suppliers",
      children: <ExpenseSuppliers />,
    },
    {
      key: "categories",
      label: "Categories",
      children: <ExpenseCategories />,
    },
    {
      key: "descriptions",
      label: "Descriptions",
      children: <ExpenseDescriptions />,
    },
  ];

  return (
    <>
      <Typography.Title level={2}>Expense Management</Typography.Title>

      <Tabs items={items} type="line" defaultActiveKey="types" />
    </>
  );
};

export default ManageExpense;
